export default "__VITE_ASSET__uhzC66Dp__"